export default "__VITE_ASSET__DVSRRStj__"